function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};









function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var bind = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
var isBuffer_1 = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
};

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

var utils = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer_1,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};

var global$1 = (typeof global !== "undefined" ? global :
            typeof self !== "undefined" ? self :
            typeof window !== "undefined" ? window : {});

// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
var cachedSetTimeout = defaultSetTimout;
var cachedClearTimeout = defaultClearTimeout;
if (typeof global$1.setTimeout === 'function') {
    cachedSetTimeout = setTimeout;
}
if (typeof global$1.clearTimeout === 'function') {
    cachedClearTimeout = clearTimeout;
}

function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
function nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
}
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
var title = 'browser';
var platform = 'browser';
var browser = true;
var env = {};
var argv = [];
var version = ''; // empty string to avoid regexp issues
var versions = {};
var release = {};
var config = {};

function noop() {}

var on = noop;
var addListener = noop;
var once = noop;
var off = noop;
var removeListener = noop;
var removeAllListeners = noop;
var emit = noop;

function binding(name) {
    throw new Error('process.binding is not supported');
}

function cwd () { return '/' }
function chdir (dir) {
    throw new Error('process.chdir is not supported');
}
function umask() { return 0; }

// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var performance = global$1.performance || {};
var performanceNow =
  performance.now        ||
  performance.mozNow     ||
  performance.msNow      ||
  performance.oNow       ||
  performance.webkitNow  ||
  function(){ return (new Date()).getTime() };

// generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime
function hrtime(previousTimestamp){
  var clocktime = performanceNow.call(performance)*1e-3;
  var seconds = Math.floor(clocktime);
  var nanoseconds = Math.floor((clocktime%1)*1e9);
  if (previousTimestamp) {
    seconds = seconds - previousTimestamp[0];
    nanoseconds = nanoseconds - previousTimestamp[1];
    if (nanoseconds<0) {
      seconds--;
      nanoseconds += 1e9;
    }
  }
  return [seconds,nanoseconds]
}

var startTime = new Date();
function uptime() {
  var currentTime = new Date();
  var dif = currentTime - startTime;
  return dif / 1000;
}

var process = {
  nextTick: nextTick,
  title: title,
  browser: browser,
  env: env,
  argv: argv,
  version: version,
  versions: versions,
  on: on,
  addListener: addListener,
  once: once,
  off: off,
  removeListener: removeListener,
  removeAllListeners: removeAllListeners,
  emit: emit,
  binding: binding,
  cwd: cwd,
  chdir: chdir,
  umask: umask,
  hrtime: hrtime,
  platform: platform,
  release: release,
  config: config,
  uptime: uptime
};

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
var createError = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
var settle = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

var isURLSameOrigin = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);

// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa$1(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

var btoa_1 = btoa$1;

var cookies = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);

var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || btoa_1;

var xhr = function xhrAdapter(config$$1) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config$$1.data;
    var requestHeaders = config$$1.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if (process.env.NODE_ENV !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config$$1.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config$$1.auth) {
      var username = config$$1.auth.username || '';
      var password = config$$1.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config$$1.method.toUpperCase(), buildURL(config$$1.url, config$$1.params, config$$1.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config$$1.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config$$1.responseType || config$$1.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config$$1,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config$$1, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config$$1.timeout + 'ms exceeded', config$$1, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies$$1 = cookies;

      // Add xsrf header
      var xsrfValue = (config$$1.withCredentials || isURLSameOrigin(config$$1.url)) && config$$1.xsrfCookieName ?
          cookies$$1.read(config$$1.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config$$1.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config$$1.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config$$1.responseType) {
      try {
        request.responseType = config$$1.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config$$1.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config$$1.onDownloadProgress === 'function') {
      request.addEventListener('progress', config$$1.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config$$1.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config$$1.onUploadProgress);
    }

    if (config$$1.cancelToken) {
      // Handle cancellation
      config$$1.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = xhr;
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults;

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

var isCancel = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults_1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager_1(),
    response: new InterceptorManager_1()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults_1, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

var Axios_1 = Axios;

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

var Cancel_1 = Cancel;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel_1(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios_1(defaultConfig);
  var instance = bind(Axios_1.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios_1.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios$2 = createInstance(defaults_1);

// Expose Axios class to allow class inheritance
axios$2.Axios = Axios_1;

// Factory for creating new instances
axios$2.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults_1, instanceConfig));
};

// Expose Cancel & CancelToken
axios$2.Cancel = Cancel_1;
axios$2.CancelToken = CancelToken_1;
axios$2.isCancel = isCancel;

// Expose all/spread
axios$2.all = function all(promises) {
  return Promise.all(promises);
};
axios$2.spread = spread;

var axios_1 = axios$2;

// Allow use of default import syntax in TypeScript
var default_1 = axios$2;

axios_1.default = default_1;

var axios = axios_1;

var SmartXEnv = typeof ENV === 'undefined' ? {
  "version": "1.0",
  "apiVersion": "3.0",
  "cmsApiVersion": "3.0",
  "environment": "staging",
  "apiPath": {
    // "dev": "clientapi-staging.smartxadvisory.com/api",
    "staging": "clientapi-staging.smartxadvisory.com/api",
    "prodTest": "clientapi-test.smartxadvisory.com/api",
    "prod": "api.smartxadvisory.com/api"
  },
  "devEnvPath": "dev-hedgecovest.pantheonsite.io",
  "stagingEnvPath": "test-hedgecovest.pantheonsite.io",
  "prodTestEnvPath": "smartx-v2-hedgecovest.pantheonsite.io",
  "prodEnvPath": "smartxadvisory.com",
  "devProtocol": "https://",
  "prodProtocol": "https://"
} : ENV;

var ENVIRONMENT = typeof SmartXEnv.environment !== 'undefined' ? SmartXEnv.environment : 'dev';
var API_VERSION = typeof SmartXEnv.apiVersion !== 'undefined' ? SmartXEnv.apiVersion : '3.0';
var BASEPATH = SmartXEnv.smartxApiUrl || (SmartXEnv.apiPath !== 'undefined' ? SmartXEnv.apiPath[ENVIRONMENT] : null);
var PROTOCOL = typeof SmartXEnv.includeProtocol !== 'undefined' && SmartXEnv.includeProtocol === false ? '' : ENVIRONMENT === 'prod' || ENVIRONMENT === 'prodTest' ? SmartXEnv.prodProtocol : SmartXEnv.devProtocol;

var Router =
/** @class */
function () {
  function Router(options) {
    if (options === void 0) {
      options = {};
    } // static edgeRequests: string[] = ['needsrebalance', 'search/models'] // reference this when determining when to add the "?edge=env" query string


    this.options = {
      bearer_token: '',
      // page_size: 25,
      // page_number: 1,
      rest_base: BASEPATH + "/",
      protocol: "" + PROTOCOL,
      request_options: {
        headers: {
          Accept: '*/*',
          Connection: 'close',
          'User-Agent': "smartx-js/" + API_VERSION
        }
      },
      environment: ENVIRONMENT,
      version: API_VERSION
    };
    this.options = _extends(this.options, options);
  } // ---
  // STATIC METHODS.
  // ---


  Router.ping = function () {
    return __awaiter(this, void 0, void 0, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , axios.get("" + PROTOCOL + BASEPATH.replace('/api', ''))];

          case 1:
            res = _a.sent();
            return [2
            /*return*/
            , res.data];
        }
      });
    });
  };

  Router.log = function (msg) {
    if (SmartXEnv && SmartXEnv.environment !== 'prod') {}
  }; // static isEdgeRequest (url: string): boolean {
  //   let result: string | undefined
  //   result = this.edgeRequests.find(path => {
  //     let rx = new RegExp(path, 'g')
  //     let matches: string[] | null = url.match(rx)
  //     return matches != null
  //   })
  //   return result !== undefined
  // }


  Router.getToken = function () {
    return this.token;
  };

  Router.setToken = function (token) {
    this.token = token;
  };

  Router.setImpersonatorId = function (id) {
    this.impersonatorId = id;
  };

  Router.getImpersonatorId = function () {
    return this.impersonatorId;
  };

  Router.setClientIp = function (ip) {
    this.clientIp = ip;
  };

  Router.getClientIp = function () {
    return this.clientIp;
  };

  Router.onRequestSuccess = function (response) {
    return Promise.resolve(response);
  };

  Router.onRequestFailure = function (response) {
    return __awaiter(this, void 0, void 0, function () {
      var errMsg, requestId, apiResponse, responseData;
      return __generator(this, function (_a) {
        errMsg = response.message; // catch expired token errors
        // if (response.response && response.response.status === 401) {
        //   if (response.response.data && response.response.data.error) {
        //     let errorResponse = response.response.data
        //     if (errorResponse && errorResponse.error === 'invalid_token') {
        //       let result = await Router.getNewToken()
        //       if (result.access_token) {
        //         // retry request
        //         Router.setToken(result.acces_token)
        //         Router.setRefreshToken(result.refresh_token)
        //         // TODO: retry the failed request with the new token
        //       } else {
        //         return Promise.reject(new Error(errorResponse.description))
        //       }
        //     }
        //   }
        // }
        // check for replicator error messages

        try {
          apiResponse = response.response; // find the error message from the api controller response
          // possible properties it may be under include: 'ErrorMessage', 'errorMessage'
          // These properties are sometimes at the top level and sometimes deeper in the envelope (accessed through .data). This checks both

          if (apiResponse && apiResponse.status !== 502 && apiResponse.data && apiResponse.data !== '' && apiResponse.data !== null) {
            responseData = apiResponse.data;

            if (responseData.data !== null) {
              errMsg = responseData.errorMessage || responseData.ErrorMessage || (responseData.data ? responseData.data.ErrorMessage || responseData.data : response.message);
              requestId = responseData.requestId || (responseData.data ? responseData.data.requestId : '');
            } // if (typeof Sentry !== 'undefined') {
            //   Sentry.withScope(scope => {
            //     let sentryErrMsg = `${errMsg}. RequestId: ${requestId}`
            //     Sentry.captureException(new Error(sentryErrMsg))
            //   })
            // }

          }
        } catch (e) {
          // if (typeof Sentry !== 'undefined') {
          //   Sentry.withScope(scope => {
          //     Sentry.captureException(response)
          //   })
          // }
          errMsg = 'An unexpected error occurred';
        }

        return [2
        /*return*/
        , Promise.reject(new Error(errMsg))];
      });
    });
  }; // replaced by 3rd party logging
  // static async logMessage (data: any): Promise<any> {
  //   let path = `${PROTOCOL}${BASEPATH}/${API_VERSION}/messages`
  //   try {
  //     await axios.post(path, data, {headers: { Authorization: `Bearer ${Router.token}` }})
  //   } catch (e) {
  //     Router.log(e.message)
  //   }
  // }
  // ---
  // PUBLIC METHODS.
  // ---
  // public getPageSize (): void {
  //   return this.options.page_size
  // }
  // public setPageSize ( value: Number ): void {
  //   this.options.page_size = value
  // }


  Router.prototype.requestToken = function (formData) {
    var path = ENVIRONMENT === 'prod' ? "auth/token" : 'auth/token';
    return this.request('post', path, formData);
  }; // why public and static versions of the same method?


  Router.prototype.getToken = function () {
    Router.log("getting token from public method");
    return Router.token;
  };

  Router.prototype.request = function (method, url, payload, extraHeaders) {
    var fullUrl = this.buildEndpoint(url);
    var config;

    if (Router.token) {
      config = {
        headers: _extends({
          Authorization: "Bearer " + Router.token,
          'Content-Type': 'application/json'
        }, extraHeaders || {}),
        withCredentials: false,
        params: method === 'get' && payload ? payload : {}
      }; // do not include the authorization header when calling token endpoints
      // calling these directly will be unnecessary once identity server migration is complete
      // if (fullUrl.indexOf('token') !== -1) {
      //   delete config.headers.Authorization
      // }

      if (Router.clientIp) config.headers['X-OriginClientIP'] = Router.clientIp;
      if (Router.impersonatorId) config.headers['X-Impersonator-Id'] = Router.getImpersonatorId();
    } else {
      return Router.onRequestFailure({
        message: 'Token has not been set.'
      });
    }

    var requestOptions = {
      method: method,
      url: fullUrl,
      headers: config ? config.headers : {},
      params: config.params // timeout: 60000

    };
    if (payload && method !== 'get') requestOptions.data = payload;
    return axios(requestOptions).then(Router.onRequestSuccess).catch(Router.onRequestFailure);
  }; // ---
  // PRIVATE METHODS.
  // ---


  Router.prototype.buildEndpoint = function (path) {
    var base = "" + this.options.rest_base;

    if (ENVIRONMENT === 'local' && path === '2.0/token') {
      base = SmartXEnv.apiDevPath + "/";
    }

    var protocol = this.options.protocol;

    if (path !== '2.0/token') {
      base = "" + base + this.options.version + "/";
    }

    return "" + protocol + base + path;
  };

  return Router;
}();

var ModelResponse =
/** @class */
function (_super) {
  __extends(ModelResponse, _super);

  function ModelResponse(responseItem) {
    var _this = _super.call(this, {}) || this;

    _extends(_this, responseItem);

    return _this;
  }

  ModelResponse.prototype.getStatistics = function () {
    return _super.prototype.request.call(this, 'get', "models/" + this.id + "/statistics");
  };

  ModelResponse.prototype.getPerformance = function (options) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', "models/" + _this.id + "/performance", options).then(function (res) {
        _this.performanceStream = res.data.data.performance;
        resolve(_this);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  ModelResponse.prototype.getHoldings = function () {
    return _super.prototype.request.call(this, 'get', "reportedmodels/" + this.reportedModelId + "/holdings");
  };

  return ModelResponse;
}(Router);

var ModelApi =
/** @class */
function (_super) {
  __extends(ModelApi, _super);

  function ModelApi() {
    var _this = _super.call(this, {}) || this;

    _this.base = 'models';
    return _this;
  }

  ModelApi.prototype.getMinimums = function (query) {
    return __awaiter(this, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', this.base + "/minimums", query)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  ModelApi.prototype.getAllModels = function (params) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base, params).then(function (res) {
        var models = res.data.data;
        var response = [];
        models.forEach(function (model) {
          response.push(new ModelResponse(model));
        });
        resolve(response);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  ModelApi.prototype.getModelById = function (ids) {
    var _this = this;

    if (ids instanceof Array) ids = ids.join(',');
    var path = ids ? this.base + "/" + ids : this.base;
    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', path).then(function (res) {
        var model = res.data.data;
        resolve(new ModelResponse(model));
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  ModelApi.prototype.getAllModelStatistics = function (status) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      var url = _this.base + "/statistics";
      if (status) url += "?status=" + status;

      _super.prototype.request.call(_this, 'get', url).then(function (res) {
        var models = res.data.data;
        resolve(models);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  ModelApi.prototype.getModelStatistics = function (id) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "/" + id + "/statistics").then(function (res) {
        var models = res.data.data;
        resolve(models);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  ModelApi.prototype.getModelPerformance = function (id, data) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "/" + id + "/performance", data).then(function (res) {
        var models = res.data.data;
        resolve(models);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  ModelApi.prototype.getAllModelPerformances = function (query) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "/performance", query).then(function (res) {
        var models = res.data.data;
        resolve(models);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  return ModelApi;
}(Router);

var CrudMethods =
/** @class */
function (_super) {
  __extends(CrudMethods, _super);

  function CrudMethods(base, options) {
    if (options === void 0) {
      options = {};
    }

    var _this = _super.call(this, options) || this;

    _this.base = base;
    return _this;
  }

  CrudMethods.prototype.get = function (id, data) {
    if (id === void 0) {
      id = undefined;
    }

    var url = id ? this.base + "/" + id : this.base;
    return _super.prototype.request.call(this, 'get', url, data);
  };

  CrudMethods.prototype.create = function (data) {
    return _super.prototype.request.call(this, 'post', this.base, data);
  };

  CrudMethods.prototype.update = function (id, data) {
    return _super.prototype.request.call(this, 'put', this.base + "/" + id, data);
  };

  CrudMethods.prototype.delete = function (id) {
    return _super.prototype.request.call(this, 'delete', this.base + "/" + id);
  };

  return CrudMethods;
}(Router);

var Account =
/** @class */
function () {
  // tslint:disable-next-line:no-empty
  function Account(obj) {
    _extends(this, obj);

    return this;
  } // ) {
  //   // Additional statistics properties
  //   if (typeof obj.availableCash !== 'undefined') this.availableCash = obj.availableCash
  //   if (typeof obj.positions !== 'undefined') this.positions = obj.positions
  //   if (typeof obj.value !== 'undefined') this.value = obj.value
  //   // If account data is nested, access through account
  //   if (typeof obj.account !== 'undefined') obj = obj.account
  //   // Default account properties
  //   if (typeof obj.id !== 'undefined') this.id = obj.id
  //   if (typeof obj.name !== 'undefined') this.name = obj.name
  //   if (typeof obj.accountTitle !== 'undefined') this.accountTitle = obj.accountTitle
  //   if (typeof obj.accountType !== 'undefined') this.accountType = obj.accountType
  //   if (typeof obj.brokerage !== 'undefined') this.brokerage = obj.brokerage
  //   if (typeof obj.brokerageAccountNumber !== 'undefined') this.brokerageAccountNumber = obj.brokerageAccountNumber
  //   if (typeof obj.features !== 'undefined') this.features = obj.features
  //   if (typeof obj.isApm !== 'undefined') this.isApm = obj.isApm
  //   if (typeof obj.isTrading !== 'undefined') this.isTrading = obj.isTrading
  //   if (typeof obj.marginType !== 'undefined') this.marginType = obj.marginType
  //   if (typeof obj.optionLevel !== 'undefined') this.optionLevel = obj.optionLevel
  //   if (typeof obj.shouldRebalance !== 'undefined') this.shouldRebalance = obj.shouldRebalance
  //   if (typeof obj.status !== 'undefined') this.status = obj.status
  //   if (typeof obj.targetWeightId !== 'undefined') this.targetWeightId = obj.targetWeightId
  //   if (typeof obj.createdOn !== 'undefined') this.created = obj.createdOn.timestamp
  //   if (typeof obj.enterprise !== 'undefined') this.enterprise = obj.enterprise
  //   if (typeof obj.permissionName !== 'undefined') this.permissionName = obj.permissionName
  //   return this
  // }


  Account.prototype.inflateHoldings = function () {
    var vm = this;
    var api = new AccountApi();
    var promise = new Promise(function (resolve, reject) {
      api.getAccountHoldings(vm.id).then(function (resp) {
        vm.holdings = resp;
        resolve(vm.holdings);
      });
    });
    return promise;
  };

  return Account;
}();

var PerformanceValueFormat =
/** @class */
function () {
  function PerformanceValueFormat() {}

  return PerformanceValueFormat;
}();

var PerformanceRangeDate =
/** @class */
function () {
  function PerformanceRangeDate() {}

  return PerformanceRangeDate;
}();

var PerformanceRange =
/** @class */
function () {
  function PerformanceRange() {}

  return PerformanceRange;
}();

var Exposure =
/** @class */
function () {
  function Exposure(obj) {
    // console.log('Exposure constructor', obj)
    if (typeof obj.exposure.gross !== 'undefined') {
      this.gross = new PerformanceValueFormat();
      this.gross.dollar = obj.exposure.gross.dollar;
      this.gross.percent = obj.exposure.gross.percent;
    }

    if (typeof obj.exposure.net !== 'undefined') {
      this.net = new PerformanceValueFormat();
      this.net.dollar = obj.exposure.net.dollar;
      this.net.percent = obj.exposure.net.percent;
    }

    if (typeof obj.exposure.long !== 'undefined') {
      this.long = new PerformanceValueFormat();
      this.long.dollar = obj.exposure.long.dollar;
      this.long.percent = obj.exposure.long.percent;
    }

    if (typeof obj.exposure.short !== 'undefined') {
      this.short = new PerformanceValueFormat();
      this.short.dollar = obj.exposure.short.dollar;
      this.short.percent = obj.exposure.short.percent;
    }

    return this;
  }

  return Exposure;
}();

var Returns =
/** @class */
function () {
  function Returns(obj) {
    if (typeof obj.returns.today !== 'undefined') {
      this.today = new PerformanceValueFormat();
      this.today.dollar = obj.returns.today.dollar;
      this.today.percent = obj.returns.today.percent;
    }

    if (typeof obj.returns.mtd !== 'undefined') {
      this.mtd = new PerformanceValueFormat();
      this.mtd.dollar = obj.returns.mtd.dollar;
      this.mtd.percent = obj.returns.mtd.percent;
    }

    if (typeof obj.returns.qtd !== 'undefined') {
      this.qtd = new PerformanceValueFormat();
      this.qtd.dollar = obj.returns.qtd.dollar;
      this.qtd.percent = obj.returns.qtd.percent;
    }

    if (typeof obj.returns.ytd !== 'undefined') {
      this.ytd = new PerformanceValueFormat();
      this.ytd.dollar = obj.returns.ytd.dollar;
      this.ytd.percent = obj.returns.ytd.percent;
    }

    return this;
  }

  return Returns;
}();

var Statistics =
/** @class */
function () {
  function Statistics(obj) {
    if (typeof obj.avgAnnualReturn !== 'undefined') {
      this.avgAnnualReturn = obj.avgAnnualReturn;
    }

    if (typeof obj.avgGain !== 'undefined') {
      this.avgGain = obj.avgGain;
    }

    if (typeof obj.avgLoss !== 'undefined') {
      this.avgLoss = obj.avgLoss;
    }

    if (typeof obj.correlation !== 'undefined') {
      this.avgAnnualReturn = obj.correlation;
    }

    if (typeof obj.exposure !== 'undefined') {
      this.exposure = new Exposure(obj);
    }

    if (typeof obj.positionCount !== 'undefined') {
      this.positionCount = obj.positionCount;
    }

    if (typeof obj.returns !== 'undefined') {
      this.returns = new Returns(obj);
    }

    if (typeof obj.sharpeRatio !== 'undefined') {
      this.sharpeRatio = obj.sharpeRatio;
    }

    if (typeof obj.sortinoRatio !== 'undefined') {
      this.sortinoRatio = obj.sortinoRatio;
    }

    if (typeof obj.stdDev !== 'undefined') {
      this.stdDev = obj.stdDev;
    }

    if (typeof obj.value !== 'undefined') {
      this.value = obj.value;
    }

    if (typeof obj.cash !== 'undefined') {
      this.cash = obj.cash;
    }

    return this;
  }

  return Statistics;
}();

var Performance =
/** @class */
function () {
  function Performance(obj) {
    // console.log('initializing performnace', obj)
    if (typeof obj.grouping !== 'undefined') {
      this.grouping = obj.grouping;
    }

    if (typeof obj.recordCnt !== 'undefined') {
      this.recordCnt = obj.recordCnt;
    }

    if (typeof obj.range !== 'undefined') {
      this.range = new PerformanceRange();

      if (typeof obj.range.start !== 'undefined') {
        this.range.start = new PerformanceRangeDate();
        this.range.start.timestamp = obj.range.start.timestamp;
        this.range.start.friendly = obj.range.start.friendly;
      }

      if (typeof obj.range.end !== 'undefined') {
        this.range.end = new PerformanceRangeDate();
        this.range.end.timestamp = obj.range.end.timestamp;
        this.range.end.friendly = obj.range.end.friendly;
      }
    }

    if (typeof obj.performance !== 'undefined') {
      this.performance = [];

      for (var i = 0; i < obj.performance.length; i++) {
        this.performance.push(new PerformanceStat(obj.performance[i]));
      } // new PerformanceStat()

    }

    return this;
  }

  return Performance;
}();

var PerformanceStat =
/** @class */
function () {
  function PerformanceStat(obj) {
    if (typeof obj.range !== 'undefined') {
      this.range = new PerformanceRange();

      if (typeof obj.range.start !== 'undefined') {
        this.range.start = new PerformanceRangeDate();
        this.range.start.timestamp = obj.range.start.timestamp;
        this.range.start.friendly = obj.range.start.friendly;
      }

      if (typeof obj.range.end !== 'undefined') {
        this.range.end = new PerformanceRangeDate();
        this.range.end.timestamp = obj.range.end.timestamp;
        this.range.end.friendly = obj.range.end.friendly;
      }
    }

    if (typeof obj.pnl !== 'undefined') {
      this.pnl = new PerformanceValueFormat();
      this.pnl.dollar = obj.pnl.dollar;
      this.pnl.percent = obj.pnl.percent;
    }

    if (typeof obj.summary !== 'undefined') {
      this.summary = new PerformanceSummary();
      this.summary.beginningMarketValue = obj.summary.beginningMarketValue;
      this.summary.decreaseByAmount = obj.summary.decreaseByAmount;
      this.summary.endingMarketValue = obj.summary.endingMarketValue;
      this.summary.fees = obj.summary.fees;
      this.summary.increaseByAmount = obj.summary.increaseByAmount;
      this.summary.isFullRange = obj.summary.isFullRange;
      this.summary.transactions = obj.summary.transactions;
    }

    return this;
  }

  return PerformanceStat;
}();

var PerformanceSummary =
/** @class */
function () {
  function PerformanceSummary() {}

  return PerformanceSummary;
}();

var ApmApi =
/** @class */
function (_super) {
  __extends(ApmApi, _super);

  function ApmApi() {
    var _this = _super.call(this, 'accounts') || this;

    _this.base = 'accounts';
    return _this;
  }

  ApmApi.prototype.getHoldings = function (id, query) {
    return _super.prototype.request.call(this, 'get', this.base + "/" + id + "/apm/holdings", query);
  };

  ApmApi.prototype.updateHoldings = function (id, payload) {
    return _super.prototype.request.call(this, 'put', this.base + "/" + id + "/apm/holdings", payload);
  };

  ApmApi.prototype.updateHoldingsBatch = function (id, payload) {
    return _super.prototype.request.call(this, 'put', this.base + "/" + id + "/apm/holdings/batch", payload);
  };

  ApmApi.prototype.getHistory = function (id, query) {
    return _super.prototype.request.call(this, 'get', this.base + "/" + id + "/apm/history", query);
  };

  return ApmApi;
}(CrudMethods);

var AccountApi =
/** @class */
function (_super) {
  __extends(AccountApi, _super);

  function AccountApi() {
    var _this = _super.call(this, 'accounts') || this;

    _this.base = 'accounts';
    _this.apm = new ApmApi();
    return _this;
  }

  AccountApi.prototype.formatData = function (obj) {
    // Return if not an object
    if (_typeof(obj) !== 'object') {
      return undefined;
    }

    if (typeof obj.custodian !== 'undefined') {
      obj.brokerageName = obj.custodian.name;
    } else {
      obj.brokerageName = obj.brokerage;
    }

    if (typeof obj.allocation !== 'undefined') {
      if (typeof obj.exposure !== 'undefined') {
        obj.allocation.exposure = obj.exposure;
        delete obj.exposure;
      }

      if (typeof obj.positions !== 'undefined') {
        obj.allocation.positions = obj.positions;
        delete obj.positions;
      }

      if (typeof obj.returns !== 'undefined') {
        obj.allocation.returns = obj.returns;
        delete obj.returns;
      }

      if (typeof obj.value !== 'undefined') {
        obj.allocation.value = obj.value;
        delete obj.value;
      }
    }

    var acct = new Account(obj.statistics ? __assign(__assign({}, obj.account), obj.statistics) : obj);

    if (typeof obj.statistics !== 'undefined') {
      acct.statistics = new Statistics(obj.statistics);
    }

    if (typeof obj.holdings !== 'undefined') {
      acct.holdings = obj;
    } // Account performance


    if (typeof obj.performance !== 'undefined') {
      acct.performance = [];

      for (var i = 0; i < obj.performance.length; i++) {
        acct.performance.push(new Performance(obj.performance[i]));
      }
    } else if (typeof obj.performances !== 'undefined') {
      acct.performance = [];

      for (var i = 0; i < obj.performances.length; i++) {
        acct.performance.push(new Performance(obj.performances[i]));
      }
    }

    return acct;
  }; // ---
  // FACADE METHODS.
  // ---
  // /api/v3/Summary/Accounts/Search


  AccountApi.prototype.getAccountsSummary = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = "summary/accounts/search";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  }; // GET /api/v3/Accounts/Redemption/{id}


  AccountApi.prototype.getSmaRedemptions = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/redemption";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  }; // POST /api/v3/Accounts/Redemption


  AccountApi.prototype.createSmaRedemption = function (payload) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/redemption";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'post', url, payload)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  AccountApi.prototype.getAllAccounts = function () {
    var _this = this;

    return this.get().then(function (res) {
      return _this.handleAccountListResponse(res);
    });
  };

  AccountApi.prototype.getAccountTargets = function (accountIds) {
    if (accountIds === void 0) {
      accountIds = [];
    }

    return _super.prototype.request.call(this, 'get', this.base + "/targets", accountIds.length ? {
      accountId: accountIds.join(',')
    } : {});
  };

  AccountApi.prototype.getAccountById = function (ids) {
    var _this = this;

    if (ids instanceof Array) ids = ids.join(',');
    var path = "" + ids;
    return this.get(path).then(function (res) {
      return _this.handleAccountResponse(res);
    });
  };

  AccountApi.prototype.createNewAccount = function (data) {
    var _this = this;

    return this.create(data).then(function (res) {
      return _this.handleAccountResponse(res);
    });
  };

  AccountApi.prototype.updateAccountById = function (id, data) {
    var _this = this;

    return this.update(id, data).then(function (res) {
      return _this.handleAccountResponse(res);
    });
  };

  AccountApi.prototype.updateAccountProperties = function (id, data) {
    return __awaiter(this, void 0, void 0, function () {
      var path, req, responseData;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.base + "/" + id + "/properties";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'put', path, data)];

          case 1:
            req = _a.sent();

            try {
              responseData = req.data;
              return [2
              /*return*/
              , responseData];
            } catch (e) {
              return [2
              /*return*/
              , e];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  AccountApi.prototype.bulkUpdateAccountProperties = function (data) {
    return __awaiter(this, void 0, void 0, function () {
      var path, req, responseData;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.base + "/bulk/properties";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'put', path, data)];

          case 1:
            req = _a.sent();

            try {
              responseData = req.data;
              return [2
              /*return*/
              , responseData];
            } catch (e) {
              return [2
              /*return*/
              , e];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  AccountApi.prototype.bulkUpdateAccountEnterprise = function (data) {
    return __awaiter(this, void 0, void 0, function () {
      var path, req, responseData;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.base + "/bulk/enterprise";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'put', path, data)];

          case 1:
            req = _a.sent();

            try {
              responseData = req.data;
              return [2
              /*return*/
              , responseData];
            } catch (e) {
              return [2
              /*return*/
              , e];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  AccountApi.prototype.getAccountProperties = function (id, data) {
    return __awaiter(this, void 0, void 0, function () {
      var path, req, responseData;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.base + "/" + id + "/properties";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'put', path, data)];

          case 1:
            req = _a.sent();

            try {
              responseData = req.data;
              return [2
              /*return*/
              , responseData];
            } catch (e) {
              return [2
              /*return*/
              , e];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  AccountApi.prototype.getAccountStatistics = function (status) {
    var _this = this;

    var url = 'statistics';
    if (status) url += "?status=" + status;
    return this.get(url).then(function (res) {
      return _this.handleAccountListResponse(res);
    });
  };

  AccountApi.prototype.getAccountStatisticsForId = function (id) {
    var _this = this;

    return this.get(id + "/statistics").then(function (res) {
      return _this.handleAccountResponse(res);
    });
  };

  AccountApi.prototype.getAccountPerformanceForId = function (id, params) {
    var _this = this;

    return this.get(id + "/performance", params).then(function (res) {
      return _this.handleAccountResponse(res);
    });
  };

  AccountApi.prototype.getAccountHoldings = function (accountId, params) {
    return this.get(accountId + "/holdings", params).then(function (resp) {
      // if (typeof resp.data !== 'undefined' && resp.data.data.length) {
      //   resp.data.data = this.formatData(resp.data.data)
      // }
      return resp.data;
    });
  };

  AccountApi.prototype.getAccountActivity = function (accountId, params) {
    return this.get(accountId + "/activity").then(function (resp) {
      return resp.data;
    });
  };

  AccountApi.prototype.createTaxLotHarvestExclusion = function (payload) {
    return _super.prototype.request.call(this, 'post', this.base + "/taxlotharvestexclusions", payload);
  };

  AccountApi.prototype.handleAccountResponse = function (resp) {
    if (typeof resp.data !== 'undefined' && resp.data.data.length) {
      resp.data.data = this.formatData(resp.data.data);
    }

    return resp.data;
  };

  AccountApi.prototype.handleAccountListResponse = function (resp) {
    var _this = this;

    if (typeof resp.data !== 'undefined' && resp.data.data.length) {
      resp.data.data = resp.data.data.map(function (val, key) {
        return _this.formatData(val);
      });
    }

    return resp.data;
  };

  AccountApi.prototype.getAccountCounts = function (payload) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/counts";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, payload)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  return AccountApi;
}(CrudMethods);

var DocumentsApi =
/** @class */
function (_super) {
  __extends(DocumentsApi, _super);

  function DocumentsApi() {
    var _this = _super.call(this, 'documents') || this;

    _this.base = 'documents';
    return _this;
  }

  return DocumentsApi;
}(CrudMethods);

var PeopleApi =
/** @class */
function (_super) {
  __extends(PeopleApi, _super);

  function PeopleApi() {
    var _this = _super.call(this, 'people') || this;

    _this.base = 'people';
    return _this;
  }

  return PeopleApi;
}(CrudMethods);

/* TaxHarvestRule methods */

var TaxHarvestRulesApi =
/** @class */
function (_super) {
  __extends(TaxHarvestRulesApi, _super); // public base: string = 'taxharvestrules'


  function TaxHarvestRulesApi() {
    var _this = _super.call(this, 'lotscreenrules') || this;

    _this.base = 'lotscreenrules';
    return _this;
  }

  return TaxHarvestRulesApi;
}(CrudMethods);

var TaxGroupsApi =
/** @class */
function (_super) {
  __extends(TaxGroupsApi, _super);

  function TaxGroupsApi() {
    var _this = _super.call(this, 'taxgroups') || this;

    _this.base = 'taxgroups';
    return _this;
  } // get (ids?: string) {
  //     if (ids instanceof Array) ids = ids.join(',')
  //     let path = (ids ? `${this.base}/${ids}` : this.base)
  //     return super.request('get', path)
  // }
  // delete (id?: string) {
  //     return super.request('delete', `${this.base}/${id}`)
  // }
  // update (id: string, data: any) {
  //     return super.request('put', `${this.base}/${id}`, data)
  // }
  // create (data: any) {
  //     return super.request('post', this.base, data)
  // }


  TaxGroupsApi.prototype.harvest = function (payload) {
    return _super.prototype.request.call(this, 'post', this.base + "/harvests/requests", payload);
  };

  TaxGroupsApi.prototype.getHarvestRequests = function (params) {
    return _super.prototype.request.call(this, 'get', this.base + "/harvests/requests/summaries", params);
  };

  TaxGroupsApi.prototype.getHarvestRequestDetails = function (params) {
    return _super.prototype.request.call(this, 'get', this.base + "/harvests/requests/summaries/details", params);
  };

  TaxGroupsApi.prototype.getHarvestDetails = function (id) {
    return _super.prototype.request.call(this, 'get', this.base + "/" + id + "/detail");
  };

  TaxGroupsApi.prototype.getHarvestSummary = function (id) {
    return _super.prototype.request.call(this, 'get', this.base + "/harvests/requests/summary/" + id);
  };

  TaxGroupsApi.prototype.createHarvestDetails = function (payload) {
    return _super.prototype.request.call(this, 'post', this.base + "/harvest/detail", payload);
  };

  TaxGroupsApi.prototype.opportunities = function (id, symbolId) {
    var endpoint = symbolId ? this.base + "/" + id + "/harvests/opportunities/" + symbolId : this.base + "/" + id + "/harvests/opportunities";
    return _super.prototype.request.call(this, 'get', endpoint);
  };

  TaxGroupsApi.prototype.lots = function (id) {
    return _super.prototype.request.call(this, 'get', this.base + "/" + id + "/taxlots");
  };

  TaxGroupsApi.prototype.accounts = function (id) {
    return _super.prototype.request.call(this, 'get', this.base + "/" + id + "/accounts");
  };

  TaxGroupsApi.prototype.addAccountToGroup = function (groupId, payload) {
    return _super.prototype.request.call(this, 'post', this.base + "/" + groupId + "/accounts", payload);
  };

  TaxGroupsApi.prototype.updateGroupAccount = function (groupId, accountId, payload) {
    return _super.prototype.request.call(this, 'put', this.base + "/" + groupId + "/accounts/" + accountId, payload);
  };

  TaxGroupsApi.prototype.deleteGroupAccount = function (groupId, accountId) {
    return _super.prototype.request.call(this, 'delete', this.base + "/" + groupId + "/accounts/" + accountId);
  };

  TaxGroupsApi.prototype.substitution = function (id, data, substitutionId) {
    if (substitutionId) return _super.prototype.request.call(this, 'put', this.base + "/" + id + "/harvestsubstitutions/" + substitutionId, data);
    return data ? _super.prototype.request.call(this, 'post', this.base + "/" + id + "/harvestsubstitutions", data) : _super.prototype.request.call(this, 'get', this.base + "/" + id + "/harvestsubstitutions");
  };

  TaxGroupsApi.prototype.closedLots = function () {
    return _super.prototype.request.call(this, 'get', this.base + "/closedtaxlots");
  };

  return TaxGroupsApi;
}(CrudMethods);

var TaxGroupAccountsApi =
/** @class */
function (_super) {
  __extends(TaxGroupAccountsApi, _super);

  function TaxGroupAccountsApi() {
    var _this = _super.call(this, 'taxgroupaccounts') || this;

    _this.base = 'taxgroupaccounts';
    return _this;
  }

  TaxGroupAccountsApi.prototype.add = function (id, payload) {
    return _super.prototype.request.call(this, 'post', this.base + "/" + id, payload);
  }; // create (data: any) {
  //     return super.request('post', this.base, data)
  // }


  TaxGroupAccountsApi.prototype.update = function (taxGroupId, data, accountId) {
    return _super.prototype.request.call(this, 'put', this.base + "/" + taxGroupId + "/" + accountId, data);
  };

  TaxGroupAccountsApi.prototype.delete = function (taxGroupId, accountId) {
    return _super.prototype.request.call(this, 'delete', this.base + "/" + taxGroupId + "/" + accountId);
  };

  return TaxGroupAccountsApi;
}(CrudMethods);

var TaxHarvestingApi =
/** @class */
function () {
  function TaxHarvestingApi() {
    this.rules = new TaxHarvestRulesApi();
    this.groups = new TaxGroupsApi();
    this.accounts = new TaxGroupAccountsApi();
  }

  return TaxHarvestingApi;
}();

var ReportedModelApi =
/** @class */
function (_super) {
  __extends(ReportedModelApi, _super);

  function ReportedModelApi() {
    var _this = _super.call(this) || this;

    _this.base = 'reportedmodels';
    return _this;
  }

  ReportedModelApi.prototype.getAllModels = function () {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base).then(function (res) {
        var models = res.data.data;
        var response = [];
        models.forEach(function (model) {
          response.push(new ModelResponse(model));
        });
        resolve(response);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  ReportedModelApi.prototype.getModelById = function (ids) {
    var _this = this;

    if (ids instanceof Array) ids = ids.join(',');
    var path = ids ? this.base + "/" + ids : this.base;
    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', path).then(function (res) {
        var model = res.data.data;
        resolve(new ModelResponse(model));
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  ReportedModelApi.prototype.create = function (data) {
    return _super.prototype.request.call(this, 'post', data, this.base);
  };

  ReportedModelApi.prototype.delete = function (id) {
    return _super.prototype.request.call(this, 'delete', this.base + "/" + id);
  };

  ReportedModelApi.prototype.batchUpdateHoldings = function (id, data) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'put', _this.base + "/" + id + "/holdingsbatch", data).then(function (res) {
        return resolve(res);
      }).catch(function (res) {
        return resolve(res);
      });
    });
    return promise;
  };

  ReportedModelApi.prototype.updateModelHoldings = function (id, data) {
    var _this = this;

    var symbol = data.symbol;
    var symbolId = data.symbolId,
        percentOfPortfolio = data.percentOfPortfolio;
    var payload = {
      symbolId: symbolId,
      percentOfPortfolio: percentOfPortfolio
    };
    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'put', _this.base + "/" + id + "/holdings", payload).then(function (res) {
        var response = __assign(__assign({}, res), {
          symbol: symbol
        });

        resolve(response);
      }).catch(function (res) {
        return resolve(__assign(__assign({}, res), {
          symbol: symbol
        }));
      });
    });
    return promise;
  };

  ReportedModelApi.prototype.getHoldings = function (id) {
    return _super.prototype.request.call(this, 'get', this.base + "/" + id + "/holdings");
  };

  ReportedModelApi.prototype.updateModelInformation = function (id, data) {
    return _super.prototype.request.call(this, 'put', data, this.base + "/" + id);
  };

  ReportedModelApi.prototype.changeHistory = function (id) {
    return _super.prototype.request.call(this, 'get', this.base + "/" + id + "/changerequesthistory");
  };

  ReportedModelApi.prototype.updatePerformance = function (id, payload) {
    return _super.prototype.request.call(this, 'post', this.base + "/" + id + "/historicalperformance", payload);
  };

  ReportedModelApi.prototype.getHistoricalPerformance = function (id) {
    return _super.prototype.request.call(this, 'get', this.base + "/" + id + "/historicalperformance");
  };

  return ReportedModelApi;
}(ModelApi);

var AssignmentTypes;

(function (AssignmentTypes) {
  AssignmentTypes["accounts"] = "accounts";
  AssignmentTypes["targets"] = "targets";
  AssignmentTypes["enterpriseTargets"] = "enterpriseTargets";
  AssignmentTypes["enterpriseAccounts"] = "enterpriseAccounts";
})(AssignmentTypes || (AssignmentTypes = {}));

var UserApi =
/** @class */
function (_super) {
  __extends(UserApi, _super);

  function UserApi() {
    var _this = _super.call(this, {}) || this;

    _this.base = 'users';
    return _this;
  }

  UserApi.prototype.get = function (id) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = id ? this.base + "/" + id : this.base;
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  }; // get the users that are part of the requesting user's enterprise


  UserApi.prototype.getEnterpriseUsers = function () {
    return __awaiter(this, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', this.base + "/enterprise")];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  UserApi.prototype.create = function (payload) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = "" + this.base;
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'post', url, payload)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  UserApi.prototype.update = function (userId, payload) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/" + userId;
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'put', url, payload)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  UserApi.prototype.delete = function (userId) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/" + userId;
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'delete', url)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  UserApi.prototype.getUserAccess = function () {
    return __awaiter(this, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', this.base + "/access")];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  UserApi.prototype.getAssignments = function (userId) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/" + userId + "/assignments";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  UserApi.prototype.createAccountAssignment = function (userId, payload) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/" + userId + "/assignments/accounts";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'post', url, payload)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  UserApi.prototype.createEnterpriseAccountAssignment = function (userId, payload) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/" + userId + "/assignments/enterpriseaccounts";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'post', url, payload)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  UserApi.prototype.updateAssignment = function (profileId, permission) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/assignments/" + profileId + "?permission=" + permission;
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'put', url)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  UserApi.prototype.deleteAssignment = function (assignmentId) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/assignments/" + assignmentId;
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'delete', url)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  UserApi.prototype.bulkCreateEnterpriseTargetsAssignment = function (payload) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/bulk/assignments/enterprisetargets";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'post', url, payload)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  UserApi.prototype.bulkCreateAssignments = function (type, payload) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/bulk/assignments/" + type;
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'post', url, payload)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  UserApi.prototype.bulkUpdateAssignments = function (payload) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/bulk/assignments";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'put', url, payload)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  UserApi.prototype.search = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/search";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  return UserApi;
}(Router);

var CompositeApi =
/** @class */
function (_super) {
  __extends(CompositeApi, _super);

  function CompositeApi() {
    var _this = _super.call(this, {}) || this;

    _this.base = 'gipscomposites';
    return _this;
  }

  CompositeApi.prototype.get = function (id) {
    var url = id ? this.base + "/" + id : this.base;
    return _super.prototype.request.call(this, 'get', url);
  };

  CompositeApi.prototype.details = function (id) {
    return _super.prototype.request.call(this, 'get', this.base + "/" + id + "/details");
  };

  return CompositeApi;
}(Router);

var ExclusionApi =
/** @class */
function (_super) {
  __extends(ExclusionApi, _super);

  function ExclusionApi() {
    var _this = _super.call(this, 'gipsexclusions') || this;

    _this.base = 'gipsexclusions';
    return _this;
  }

  return ExclusionApi;
}(CrudMethods);

var ReportingApi =
/** @class */
function (_super) {
  __extends(ReportingApi, _super);

  function ReportingApi() {
    var _this = _super.call(this, {}) || this;

    _this.composite = new CompositeApi();
    _this.exclusion = new ExclusionApi();
    return _this;
  }

  return ReportingApi;
}(Router);

var Allocation =
/** @class */
function () {
  function Allocation(obj) {
    // console.log('Allocation Constuctor', obj)
    if (typeof obj.value !== 'undefined') {
      this.value = obj.value;
    }

    if (typeof obj.positions !== 'undefined') {
      this.positions = obj.positions;
    } // Allocation statistics - exposure
    // console.log('Allocation statistics exposure', obj)


    if (typeof obj.exposure !== 'undefined') {
      this.exposure = new Exposure(obj);
    } // Allocation statistics - returns


    if (typeof obj.returns !== 'undefined') {
      this.returns = new Returns(obj);
    } // If account data is nested, access through account


    if (typeof obj.allocation !== 'undefined') obj = obj.allocation;

    if (typeof obj.performances !== 'undefined') {
      this.performance = [];

      for (var i = 0; i < obj.performances.length; i++) {
        this.performance.push(new Performance(obj.performances[i]));
      }
    }

    if (typeof obj.allocations !== 'undefined') {
      var alloc = obj.allocations[0]; // console.log('allocations constructor', obj, alloc)

      if (typeof obj.value !== 'undefined') {
        this.value = obj.value;
      }

      if (typeof obj.positions !== 'undefined') {
        this.positions = obj.positions;
      } // Allocation statistics - exposure


      if (typeof obj.exposure !== 'undefined') {
        this.exposure = new Exposure(obj);
      } // Allocation statistics - returns


      if (typeof obj.returns !== 'undefined') {
        this.returns = new Returns(obj);
      }

      obj = obj.allocations[0];
    }

    if (typeof obj.id !== 'undefined') this.id = obj.id;
    if (typeof obj.name !== 'undefined') this.name = obj.name;
    if (typeof obj.type !== 'undefined') this.type = obj.type;
    if (typeof obj.leverage !== 'undefined') this.leverage = obj.leverage;
    if (typeof obj.matchModelLeverage !== 'undefined') this.matchModelLeverage = obj.matchModelLeverage;
    if (typeof obj.status !== 'undefined') this.status = obj.status;
    if (typeof obj.isApmAllocation !== 'undefined') this.isApmAllocation = obj.isApmAllocation;

    if (typeof obj.account !== 'undefined') {
      this.account = new Account(obj.account);
    }

    if (typeof obj.openTimestamp !== 'undefined' && obj.openTimestamp !== null) {
      this.openTimestamp = new PerformanceRangeDate();
      this.openTimestamp.timestamp = obj.openTimestamp.timestamp;
      this.openTimestamp.friendly = obj.openTimestamp.friendly;
    }

    if (typeof obj.closeTimestamp !== 'undefined' && obj.closeTimestamp !== null) {
      this.closeTimestamp = new PerformanceRangeDate();
      this.closeTimestamp.timestamp = obj.closeTimestamp.timestamp;
      this.closeTimestamp.friendly = obj.closeTimestamp.friendly;
    }

    if (typeof obj.inceptionDate !== 'undefined' && obj.inceptionDate !== null) {
      this.inceptionDate = new PerformanceRangeDate();
      this.inceptionDate.timestamp = obj.inceptionDate.timestamp;
      this.inceptionDate.friendly = obj.inceptionDate.friendly;
    }

    if (typeof obj.model !== 'undefined' && obj.model !== null) {
      var model = {
        id: obj.model.id || null,
        name: obj.model.name || null,
        type: obj.model.type || null,
        status: obj.model.status || null,
        reportedModelId: obj.model.reportedModelId || null,
        startedTracking: obj.model.startedTracking || null
      };
      this.model = model;
    } // console.log('allocation constructor', this)


    return this;
  }

  return Allocation;
}();

var ChangeRequestApi =
/** @class */
function (_super) {
  __extends(ChangeRequestApi, _super);

  function ChangeRequestApi() {
    var _this = _super.call(this, 'allocationchangerequests') || this;

    _this.base = 'allocationchangerequests';
    return _this;
  }

  return ChangeRequestApi;
}(CrudMethods);

var AllocationApi =
/** @class */
function (_super) {
  __extends(AllocationApi, _super);

  function AllocationApi() {
    var _this = _super.call(this, 'allocations') || this;

    _this.base = 'allocations';
    _this.requests = new ChangeRequestApi();
    return _this;
  }

  AllocationApi.prototype.formatData = function (obj) {
    // Return if not an object
    if (_typeof(obj) !== 'object') {
      Router.log("allocation object check failed " + obj);
      return undefined;
    }

    var alloc = new Allocation(obj); // Account statistics

    if (typeof obj.statistics !== 'undefined') {
      alloc.statistics = new Statistics(obj.statistics);
    } // Account performance


    if (typeof obj.performance !== 'undefined') {
      alloc.performance = [];

      for (var i = 0; i < obj.performance.length; i++) {
        alloc.performance.push(new Performance(obj.performance[i]));
      }
    } else if (typeof obj.performances !== 'undefined') {
      alloc.performance = [];

      for (var i = 0; i < obj.performances.length; i++) {
        alloc.performance.push(new Performance(obj.performances[i]));
      }
    } // console.log('Allocation obj', alloc, obj)


    return alloc;
  }; // ---
  // FACADE METHODS.
  // ---


  AllocationApi.prototype.downloadPerformance = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var path, extraHeaders;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.base + "/performance/download";
            extraHeaders = {
              'X-SMArtX-Get-Original-Headers': 'yes'
            };
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', path, params, extraHeaders)];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  AllocationApi.prototype.getAllAllocations = function (payload) {
    var _this = this;

    return this.get(undefined, payload).then(function (resp) {
      if (typeof resp.data !== 'undefined' && resp.data.data.length) {
        resp.data.data = resp.data.data.map(function (val, key) {
          return _this.formatData(val);
        });
      }

      return resp.data;
    });
  };

  AllocationApi.prototype.getAllocationById = function (ids) {
    var _this = this;

    if (ids instanceof Array) ids = ids.join(',');
    var path = "" + ids;
    return this.get(path).then(function (resp) {
      if (typeof resp.data !== 'undefined' && resp.data.data.length) {
        resp.data.data = _this.formatData(resp.data.data);
      }

      return resp.data;
    });
  };

  AllocationApi.prototype.createNewAllocation = function (data) {
    var _this = this;

    return this.create(data).then(function (resp) {
      if (typeof resp.data !== 'undefined' && resp.data.data.length) {
        resp.data.data = _this.formatData(resp.data.data);
      }

      return resp.data;
    });
  };

  AllocationApi.prototype.updateTargetEquity = function (id, targetEquity, form) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/" + id + "/target?targetEquity=" + targetEquity;
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'put', url, form)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  AllocationApi.prototype.redeem = function (id, payload) {
    var _this = this;

    var data = {
      trackManagerLeverage: payload.trackManagerLeverage || true,
      leverage: payload.leverage || 1
    };
    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'put', _this.base + "/" + id + "/redeem?amount=" + payload.amount, data).then(function (res) {
        var results = res.data;
        resolve(results);
      }).catch(function (err) {
        reject(err);
      });
    });
    return promise;
  };

  AllocationApi.prototype.increase = function (id, payload) {
    var _this = this;

    var data = {
      trackManagerLeverage: payload.trackManagerLeverage,
      leverage: payload.leverage
    };
    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'put', _this.base + "/" + id + "/increase?amount=" + payload.amount, data).then(function (res) {
        var results = res.data;
        resolve(results);
      }).catch(function (err) {
        reject(err);
      });
    });
    return promise;
  };

  AllocationApi.prototype.updateAllocationById = function (id, data) {
    var _this = this;

    return this.update(data, 'allocations/' + id).then(function (resp) {
      if (typeof resp.data !== 'undefined' && resp.data.data.length) {
        resp.data.data = _this.formatData(resp.data.data);
      }

      return resp.data;
    });
  };

  AllocationApi.prototype.getAllocationStatistics = function (data, allocation) {
    var _this = this;

    return this.get('statistics', data).then(function (resp) {
      if (typeof resp.data !== 'undefined' && resp.data.data.length) {
        resp.data.data = resp.data.data.map(function (val, key) {
          return _this.formatData(_extends({}, val.allocation, val.statistics));
        });
      }

      if (typeof allocation !== 'undefined') {
        allocation.data.map(function (alloc) {
          var stat = resp.data.data ? resp.data.data.filter(function (_stat) {
            return _stat.id === alloc.id;
          }) : [];

          if (stat.length
          /*&& typeof stat[0].statistics !== 'undefined'*/
          ) {
              alloc.statistics = stat[0]; // .statistics
            }

          return alloc;
        });
        return allocation;
      } else {
        return resp.data;
      }
    });
  };

  AllocationApi.prototype.getAllocationStatisticsById = function (id) {
    var _this = this;

    return this.get(id + "/statistics").then(function (resp) {
      if (typeof resp.data !== 'undefined' && resp.data.data.length) {
        resp.data.data = _this.formatData(resp.data.data);
      }

      return resp.data;
    });
  };

  AllocationApi.prototype.getAllocationPerformancesById = function (id, params) {
    var _this = this;

    return this.get(id + "/performance", params).then(function (resp) {
      if (typeof resp.data !== 'undefined' && resp.data.data.length) {
        resp.data.data = _this.formatData(resp.data.data);
      }

      return resp.data;
    });
  };

  AllocationApi.prototype.getInflatedAllocations = function (payload) {
    var _this = this;

    return this.getAllAllocations(payload).then(function (resp) {
      Router.log("getInflatedAllocations " + resp);
      return _this.getAllocationStatistics(payload, resp);
    }).then(function (resp) {
      Router.log("getInflatedAllocations with stats " + resp);
      return resp;
    });
  };

  AllocationApi.prototype.getAllocationsPerformance = function (id, params) {
    if (params) return this.get("performance", params);else return this.get("performance?modelids=" + id + "&grouping=m");
  };

  AllocationApi.prototype.getAllocationHoldings = function (id, params) {
    return this.get(id + "/holdings", params).then(function (resp) {
      return resp.data;
    });
  };

  AllocationApi.prototype.getAllocationHistory = function (id, params) {
    return this.get(id + "/history", params).then(function (resp) {
      return resp.data;
    });
  };

  AllocationApi.prototype.getAccountsWithNonzeroFunding = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/nonzerosleeve";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  AllocationApi.prototype.downloadAccountsWithNonzeroFunding = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/nonzerosleeve/download";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  return AllocationApi;
}(CrudMethods);

var DrupalModel =
/** @class */
function (_super) {
  __extends(DrupalModel, _super);

  function DrupalModel(options) {
    var _this = _super.call(this, options) || this; // this.options.rest_base = 'http://eg2-hedgecovest.pantheonsite.io'
    // this.options.rest_base = (ENV.environment === 'dev') ? ENV.devEnvPath : ENV.prodEnvPath


    _this.base = 'models';
    return _this;
  }

  DrupalModel.prototype.getAllModels = function () {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base).then(function (res) {
        resolve(res.data);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  DrupalModel.prototype.getRecentlyAddedModels = function (limit) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "/recentlyAdded?limit=" + limit).then(function (res) {
        resolve(res.data);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  DrupalModel.prototype.getModelById = function (ids, guidType) {
    var _this = this;

    if (ids instanceof Array) ids = ids.join(',');
    var path = ids ? this.base + "/" + ids + "?type=" + guidType : this.base;
    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', path).then(function (res) {
        resolve(res);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  DrupalModel.prototype.getModelCommentary = function (id, limit) {
    var _this = this;

    var path = this.base + "/" + id + "/commentary?limit=" + limit;
    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', path).then(function (res) {
        resolve(res);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  return DrupalModel;
}(Router);

var DrupalCommentary =
/** @class */
function (_super) {
  __extends(DrupalCommentary, _super);

  function DrupalCommentary(options) {
    var _this = _super.call(this, options) || this; // this.options.rest_base = 'http://eg2-hedgecovest.pantheonsite.io'
    // this.options.rest_base = (ENV.environment === 'dev') ? ENV.devEnvPath : ENV.prodEnvPath


    _this.base = 'commentary';
    return _this;
  }

  DrupalCommentary.prototype.getRecentlyAddedCommentary = function (limit) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "/recentlyAdded?limit=" + limit).then(function (res) {
        resolve(res.data);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  DrupalCommentary.prototype.getRecentlyAddedWebinars = function (limit) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "/recentlyAdded?limit=" + limit + "&type=webinar").then(function (res) {
        resolve(res.data);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  return DrupalCommentary;
}(Router);

var CmsApi =
/** @class */
function () {
  function CmsApi() {
    var options = {
      rest_base: SmartXEnv.drupalApiUrl || (SmartXEnv.environment === 'prod' ? SmartXEnv.prodEnvPath : SmartXEnv.environment === 'test' ? SmartXEnv.testEnvPath : SmartXEnv.devEnvPath),
      version: SmartXEnv.cmsApiVersion || '3.0'
    };
    if (SmartXEnv.environment === 'prodTest') options.rest_base = SmartXEnv.prodTestEnvPath;
    options.rest_base = options.rest_base + '/';
    this.modelsApi = new DrupalModel(options);
    this.commentaryApi = new DrupalCommentary(options);
  } // ---
  // FACADE METHODS.
  // ---


  CmsApi.prototype.getAllModels = function () {
    return this.modelsApi.getAllModels().then(function (resp) {
      Router.log("CmsApi/getAllModels " + JSON.stringify(resp, null, 4));
      return resp.data;
    });
  };

  CmsApi.prototype.getRecentlyAddedModels = function (limit) {
    return this.modelsApi.getRecentlyAddedModels(limit).then(function (resp) {
      Router.log("CmsApi/getRecentlyAddedModels " + resp);
      return resp.data;
    });
  };

  CmsApi.prototype.getModelById = function (id, guidType) {
    return this.modelsApi.getModelById(id, guidType).then(function (resp) {
      Router.log("CmsApi/getModelById " + resp);
      return resp.data;
    });
  };

  CmsApi.prototype.getModelCommentary = function (id, limit) {
    return this.modelsApi.getModelCommentary(id, limit).then(function (resp) {
      Router.log("CmsApi/getModelCommentary " + resp);
      return resp.data;
    });
  };
  /*********** COMMENTARY API ***********/


  CmsApi.prototype.getRecentlyAddedCommentary = function (limit) {
    return this.commentaryApi.getRecentlyAddedCommentary(limit).then(function (resp) {
      Router.log("CmsApi/getRecentlyAddedCommentary " + resp);
      return resp.data;
    });
  };

  CmsApi.prototype.getRecentlyAddedWebinars = function (limit) {
    return this.commentaryApi.getRecentlyAddedWebinars(limit).then(function (resp) {
      Router.log("CmsApi/getRecentlyAddedWebinars " + resp);
      return resp.data;
    });
  };

  return CmsApi;
}();

var SymbolApi =
/** @class */
function (_super) {
  __extends(SymbolApi, _super);

  function SymbolApi() {
    var _this = _super.call(this, 'symbols') || this;

    _this.base = 'symbols';
    return _this;
  }

  SymbolApi.prototype.searchAllSymbols = function (params) {
    if (params === void 0) {
      params = {};
    }

    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/search";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent();
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  SymbolApi.prototype.getFlagsApiUrl = function () {
    var env = SmartXEnv && SmartXEnv.environment;

    if (env && SmartXEnv.flagApiPath) {
      var url = SmartXEnv.flagApiPath[env];
      return url || SmartXEnv.flagApiPath.default;
    }

    return null;
  }; // used to get symbols for large portfolios that create excessive query strings


  SymbolApi.prototype.getPortfolioSymbols = function (data, params) {
    var _this = this;

    if (params === void 0) {
      params = {};
    }

    var qs = Object.keys(params).map(function (key) {
      return key + '=' + params[key];
    }).join('&');
    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'post', _this.base + "?" + qs, data).then(function (res) {
        return resolve(res);
      }).catch(function (res) {
        return resolve(res);
      });
    });
    return promise;
  };

  SymbolApi.prototype.getFlaggedSymbols = function (variables) {
    if (variables === void 0) {
      variables = {};
    }

    return __awaiter(this, void 0, void 0, function () {
      var url, query, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.getFlagsApiUrl();
            if (!url) return [3
            /*break*/
            , 2];
            query = "query ($input: ListFlagsInput) {\n                        listFlags(input: $input) {\n                            objectId\n                            status\n                            objectName\n                            objectType\n                            assetType\n                            createdOn\n                            updatedOn\n                        }\n                      }";
            return [4
            /*yield*/
            , axios.post(url, {
              query: query,
              variables: variables
            }, {
              headers: {
                "Content-type": 'application/json',
                "Authorization": "Bearer " + _super.prototype.getToken.call(this)
              }
            })];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];

          case 2:
            return [2
            /*return*/
            , Promise.reject(new Error("Flag API url not found"))];
        }
      });
    });
  };

  return SymbolApi;
}(CrudMethods);

var JobApi =
/** @class */
function (_super) {
  __extends(JobApi, _super);

  function JobApi() {
    var _this = _super.call(this, {}) || this;

    _this.base = 'jobs';
    return _this;
  }

  JobApi.prototype.get = function (id) {
    var url = id ? this.base + "/" + id : this.base;
    return _super.prototype.request.call(this, 'get', url);
  };

  return JobApi;
}(Router);

var TradeLogic;

(function (TradeLogic) {
  TradeLogic["bestFit"] = "bestFit";
  TradeLogic["minTransaction"] = "minTransaction";
})(TradeLogic || (TradeLogic = {}));

var HistorySortKeys;

(function (HistorySortKeys) {
  HistorySortKeys["accountCount"] = "accountCount";
  HistorySortKeys["requestDate"] = "requestDate";
  HistorySortKeys["failedCount"] = "failedCount";
  HistorySortKeys["completeCount"] = "completeCount";
  HistorySortKeys["completeWithErrorsCount"] = "completeWithErrorsCount";
})(HistorySortKeys || (HistorySortKeys = {}));

var HistorySortDirection;

(function (HistorySortDirection) {
  HistorySortDirection["desc"] = "desc";
  HistorySortDirection["asc"] = "asc";
})(HistorySortDirection || (HistorySortDirection = {}));

var CompletedHistoryStatuses;

(function (CompletedHistoryStatuses) {
  CompletedHistoryStatuses["complete"] = "complete";
  CompletedHistoryStatuses["failed"] = "failed";
  CompletedHistoryStatuses["completeWithErrors"] = "completeWithErrors";
  CompletedHistoryStatuses["cancelled"] = "cancelled";
  CompletedHistoryStatuses["expired"] = "expired";
})(CompletedHistoryStatuses || (CompletedHistoryStatuses = {}));

var RebalancerApi =
/** @class */
function (_super) {
  __extends(RebalancerApi, _super);

  function RebalancerApi() {
    return _super.call(this, 'rebalancerequests') || this;
  }

  RebalancerApi.prototype.cancel = function (id) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'put', _this.base + "/" + id + "/cancel").then(function (res) {
        var results = res.data.data;
        resolve(results);
      }).catch(function (err) {
        reject(err);
      });
    });
    return promise;
  };

  RebalancerApi.prototype.authorize = function (payload) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'put', _this.base + "/" + payload.id + "/authorize?logic=" + payload.logic).then(function (res) {
        var results = res.data.data;
        resolve(results);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  RebalancerApi.prototype.getResults = function (id) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "/" + id + "/results").then(function (res) {
        var results = res.data.data;
        resolve(results);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  RebalancerApi.prototype.needsRebalance = function () {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "/needsrebalance").then(function (res) {
        var results = res.data;
        resolve(results);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  RebalancerApi.prototype.rebalanceRequests = function () {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base).then(function (res) {
        var results = res.data;
        resolve(results);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  RebalancerApi.prototype.rebalanceActiveRequests = function () {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "?status=working&status=pendingApproval&status=pending&status=rebalancing").then(function (res) {
        var results = res.data;
        resolve(results);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  RebalancerApi.prototype.rebalanceHistory = function (payload) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "/history", payload).then(function (res) {
        var results = res.data;
        resolve(results);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  RebalancerApi.prototype.rebalanceHistoryUsers = function () {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "/history/filter").then(function (res) {
        var results = res.data;
        resolve(results);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  return RebalancerApi;
}(CrudMethods);

var BenchmarkApi =
/** @class */
function (_super) {
  __extends(BenchmarkApi, _super);

  function BenchmarkApi() {
    return _super.call(this, 'benchmarks') || this; // this.base = 'benchmarks'
  }

  BenchmarkApi.prototype.getPerformance = function (id, payload) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "/" + id + "/performance", payload).then(function (resp) {
        resolve(resp.data.data);
      }).catch(function (err) {
        reject(err);
      });
    });
    return promise;
  };

  BenchmarkApi.prototype.getStatistics = function (id, payload) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "/" + id + "/statistics", payload).then(function (resp) {
        resolve(resp.data.data);
      }).catch(function (err) {
        reject(err);
      });
    });
    return promise;
  };

  return BenchmarkApi;
}(CrudMethods);

var TargetWeightGroupApi =
/** @class */
function (_super) {
  __extends(TargetWeightGroupApi, _super);

  function TargetWeightGroupApi() {
    var _this = _super.call(this, 'targetweightgroups') || this;

    _this.base = 'targetweightgroups';
    return _this;
  }

  TargetWeightGroupApi.prototype.getTargets = function (id, params) {
    var path = id ? "targets/" + id : 'targets';
    return _super.prototype.request.call(this, 'get', path, params);
  };

  TargetWeightGroupApi.prototype.getTargetsAccounts = function () {
    var path = "targets/accounts";
    return _super.prototype.request.call(this, 'get', path);
  };

  TargetWeightGroupApi.prototype.getFlattenedDetails = function (id) {
    var path = "targets/" + id + "/flatten";
    return _super.prototype.request.call(this, 'get', path);
  };

  TargetWeightGroupApi.prototype.getDetails = function (id) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "/" + id + "/details").then(function (res) {
        var results = res.data;
        resolve(results);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  TargetWeightGroupApi.prototype.addDetails = function (details) {
    return _super.prototype.request.call(this, 'post', 'targets/details', details);
  };

  TargetWeightGroupApi.prototype.updateDetails = function (id, details) {
    return _super.prototype.request.call(this, 'put', "targets/" + id + "/details", details);
  };

  TargetWeightGroupApi.prototype.addDetail = function (id, payload) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'post', _this.base + "/" + id + "/details", payload).then(function (res) {
        var results = res.data;
        resolve(results);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  TargetWeightGroupApi.prototype.getDetail = function (targetId, detailId, query) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'post', _this.base + "/" + targetId + "/details/" + detailId, query).then(function (res) {
        var results = res.data;
        resolve(results);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  TargetWeightGroupApi.prototype.updateDetail = function (targetId, detailId, payload) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'put', _this.base + "/" + targetId + "/details/" + detailId, payload).then(function (res) {
        var results = res.data;
        resolve(results);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  TargetWeightGroupApi.prototype.deleteDetail = function (targetId, detailId) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'delete', _this.base + "/" + targetId + "/details/" + detailId).then(function (res) {
        var results = res.data;
        resolve(results);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  TargetWeightGroupApi.prototype.getAccountsByTarget = function (targetId, params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = "targets/" + targetId + "/accounts";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  return TargetWeightGroupApi;
}(CrudMethods);

var EnterprisesApi =
/** @class */
function (_super) {
  __extends(EnterprisesApi, _super);

  function EnterprisesApi() {
    return _super.call(this, 'enterprises') || this;
  }

  EnterprisesApi.prototype.getAll = function () {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/all";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  EnterprisesApi.prototype.summary = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = "summary/enterprises";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  EnterprisesApi.prototype.search = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = "summary/enterprises/search";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  EnterprisesApi.prototype.getAUM = function (query) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "/aum", query).then(function (res) {
        var results = res.data;
        resolve(results);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  EnterprisesApi.prototype.getAllocations = function (query) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "/allocations", query).then(function (res) {
        var results = res.data;
        resolve(results);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  EnterprisesApi.prototype.assignRepCodes = function (payload) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/repcodes";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'put', url, payload)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  EnterprisesApi.prototype.getAdvisors = function (query) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "/advisors", query).then(function (res) {
        var results = res.data;
        resolve(results);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  EnterprisesApi.prototype.getModels = function (enterpriseId, params) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "/" + enterpriseId + "/models", params).then(function (res) {
        var results = res.data;
        resolve(results);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  EnterprisesApi.prototype.getModelReport = function (enterpriseId) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      var url = enterpriseId ? _this.base + "/" + enterpriseId + "/reports/model" : _this.base + "/reports/model";

      _super.prototype.request.call(_this, 'get', url).then(function (res) {
        var results = res.data;
        resolve(results);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  EnterprisesApi.prototype.getModelAllocationReport = function (modelId) {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _super.prototype.request.call(_this, 'get', _this.base + "/reports/model/" + modelId + "/allocations").then(function (res) {
        var results = res.data;
        resolve(results);
      }).catch(function (err) {
        reject(new Error(err));
      });
    });
    return promise;
  };

  return EnterprisesApi;
}(CrudMethods);

var SortOptions;

(function (SortOptions) {
  SortOptions["today"] = "today";
  SortOptions["ytd"] = "ytd";
  SortOptions["mtd"] = "mtd";
  SortOptions["qtd"] = "qtd";
})(SortOptions || (SortOptions = {}));

var OrderOptions;

(function (OrderOptions) {
  OrderOptions["ascd"] = "ascd";
  OrderOptions["desc"] = "desc";
})(OrderOptions || (OrderOptions = {})); // lambda functions


var PerformanceApi =
/** @class */
function (_super) {
  __extends(PerformanceApi, _super);

  function PerformanceApi(platform) {
    if (platform === void 0) {
      platform = 'ad0fb0f8-6440-4611-802a-d793623e537b';
    }

    var _this = _super.call(this, {}) || this;

    _this.platform = platform; // 'https://performance-testing.smartxadvisory.com/models/'

    _this.base = _this.setBase(_this.options.environment); // this.options.environment === 'prod' ? 'https://performance.smartxadvisory.com/models/' : 'https://performance.development.smartxadvisory.com/models/'

    return _this;
  }

  PerformanceApi.prototype.setBase = function (environment) {
    if (environment === void 0) {
      environment = '';
    }

    switch (environment) {
      case 'prod':
      case 'prodTest':
      case 'test':
        return 'https://performance.smartxadvisory.com/models/';
      // case 'prodTest':
      //   return 'https://performance-testing.smartxadvisory.com/models/';

      default:
        // return https://performance.development.smartxadvisory.com/models/
        return 'https://api.gtw.qa.smartx.us/api/performance/models/';
    }
  };

  PerformanceApi.prototype.request = function (route, query) {
    if (route === void 0) {
      route = '';
    }

    if (query === void 0) {
      query = {};
    }

    query = _extends(query, {
      platform: this.platform
    }); // console.log(`Making call to ${this.base}${route} with query: ${JSON.stringify(query)}`)
    // use API-KEY header for staging

    var options = {
      params: query,
      headers: this.options.environment === 'prod' ? {} : {
        'X-API-KEY': 'eqsgXmKKVZ1P0XxJFnZJg3PrejuouIURwjJm1U71'
      }
    };

    if (this.options.version == "3.1") {
      options.headers["Authorization"] = "Bearer " + Router.getToken();
    }

    return axios.get("" + this.base + route, options);
  }; // replaces the search call which contains replicator data as well as drupal metadata


  PerformanceApi.prototype.modelsSearch = function () {
    return this.request('search');
  };

  PerformanceApi.prototype.portfolioPerformance = function (params) {
    return this.request('performance', params);
  }; // returns model metadata from drupal


  PerformanceApi.prototype.modelProfiles = function () {
    return this.request();
  }; // returns replicator models with information and statistics


  PerformanceApi.prototype.modelsSummary = function () {
    return this.request('summary');
  };

  PerformanceApi.prototype.modelsSorted = function (params) {
    return this.request('sorted', params);
  };

  return PerformanceApi;
}(Router);

var ExclusionsApi =
/** @class */
function (_super) {
  __extends(ExclusionsApi, _super);

  function ExclusionsApi(options) {
    return _super.call(this, 'accounts/exclusions', options) || this;
  }

  ExclusionsApi.prototype.updateAccountExclusion = function (id, payload) {
    var url = this.base + "/" + id;
    return _super.prototype.request.call(this, 'put', url, payload);
  };

  ExclusionsApi.prototype.getAccountExclusions = function (id) {
    var url = "accounts/" + id + "/exclusions";
    return _super.prototype.request.call(this, 'get', url);
  };

  ExclusionsApi.prototype.getAccountExclusionsBySymbol = function (id, symbolId) {
    var url = "accounts/" + id + "/exclusions/" + symbolId;
    return _super.prototype.request.call(this, 'get', url);
  };

  ExclusionsApi.prototype.getAccountTradeBreaks = function (id) {
    var url = 'accounts/tradebreaks';
    if (id) url = "accounts/" + id + "/tradebreaks";
    return _super.prototype.request.call(this, 'get', url);
  };

  ExclusionsApi.prototype.getTradeBreakById = function (id) {
    var url = "accounts/tradebreaks/" + id;
    return _super.prototype.request.call(this, 'get', url);
  };

  ExclusionsApi.prototype.getExclusionsByTaxGroup = function (taxGroupId) {
    var url = "accounts/exclusions/bytaxgroup?taxgroupid=" + taxGroupId;
    return _super.prototype.request.call(this, 'get', url);
  };

  return ExclusionsApi;
}(CrudMethods);

var FlagsApi =
/** @class */
function (_super) {
  __extends(FlagsApi, _super);

  function FlagsApi() {
    return _super.call(this) || this;
  }

  FlagsApi.prototype.get = function (type, params) {
    var url = type + "/flags";
    return _super.prototype.request.call(this, 'get', url, params);
  };

  return FlagsApi;
}(Router);

var AdvisoryApi =
/** @class */
function (_super) {
  __extends(AdvisoryApi, _super);

  function AdvisoryApi() {
    return _super.call(this, 'advisorydashboard') || this;
  }

  AdvisoryApi.prototype.getDateOptions = function () {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/dateoptions";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  AdvisoryApi.prototype.getEnterpriseExclusions = function (enterpriseId, params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/firm/" + enterpriseId + "/accountexclusions";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  AdvisoryApi.prototype.getAccountsAumInPeriod = function (enterpriseId, params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/firm/" + enterpriseId + "/accountsauminperiod";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  AdvisoryApi.prototype.getAumOverviewByEnterprise = function (enterpriseId, params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/firm/" + enterpriseId + "/aumoverview";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  AdvisoryApi.prototype.getGroupTypeAumInPeriod = function (enterpriseId, params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/firm/" + enterpriseId + "/grouptypeauminperiod";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  AdvisoryApi.prototype.getNonBillableAccountsInPeriod = function (enterpriseId, params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/firm/" + enterpriseId + "/nonbillableaccountsinperiod";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  AdvisoryApi.prototype.getAumInPeriod = function (enterpriseId, params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/firm/" + enterpriseId + "/auminperiod";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  AdvisoryApi.prototype.getAccountEffectiveFee = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/account/effectivefee";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  }; // get account exclusions from one or more firms


  AdvisoryApi.prototype.getExclusionsByFirm = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/firm/accountexclusions";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  }; // get account exclusions for one or more accounts


  AdvisoryApi.prototype.getExclusionsByAccount = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/account/accountexclusions";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  AdvisoryApi.prototype.getAumOverview = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/firm/aumoverview";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  AdvisoryApi.prototype.getAllFirmsGroupAum = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/firm/groupaum";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  AdvisoryApi.prototype.getNonBillable = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/firm/nonbillable";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  AdvisoryApi.prototype.getSummary = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/firm/summary";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  AdvisoryApi.prototype.getAccountProgramFees = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/account/programfees";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  AdvisoryApi.prototype.getAccountsByGroupId = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/firm/groupaccountsaum";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  AdvisoryApi.prototype.getInsufficientFundsAccounts = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/account/insufficientfunds";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  return AdvisoryApi;
}(CrudMethods);

var BillingStatusApi =
/** @class */
function (_super) {
  __extends(BillingStatusApi, _super);

  function BillingStatusApi() {
    return _super.call(this, 'billingstatus') || this;
  }

  BillingStatusApi.prototype.getBillingItemDetails = function (accountId) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/lineitemdetails/" + accountId;
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  BillingStatusApi.prototype.getCustodianLineItemsByAccountIds = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/custodianlineitemsbyaccountids";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  BillingStatusApi.prototype.getLineItemHistory = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/lineitemhistory";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  BillingStatusApi.prototype.getLineItems = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/lineitems";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  BillingStatusApi.prototype.getLineItemsByAccountIds = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/lineitemsbyaccountids";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  BillingStatusApi.prototype.getPayouts = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/payouts";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  BillingStatusApi.prototype.getSufficientFundsProcess = function (pin, params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/sufficientfundsprocess/" + pin;
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  BillingStatusApi.prototype.getSufficientFundsBatch = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/sufficientfundsbatch";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  return BillingStatusApi;
}(CrudMethods);

var ComputeEngineApi =
/** @class */
function (_super) {
  __extends(ComputeEngineApi, _super);

  function ComputeEngineApi() {
    return _super.call(this, 'computeengine') || this;
  }

  ComputeEngineApi.prototype.computeAum = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/computeaum";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  ComputeEngineApi.prototype.computeAumBasis = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/computeaumbasis";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  ComputeEngineApi.prototype.computeAccountAumData = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/accountaumdata";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  ComputeEngineApi.prototype.getBillingRecords = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/FilterBillingRecords";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  ComputeEngineApi.prototype.getBillingRecordsByAccount = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/billingrecords/account";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  ComputeEngineApi.prototype.getRollupBillingRecordsByAccount = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/billingrecords/accountrollup";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  ComputeEngineApi.prototype.getAllAccountRollups = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/billingrecords/allaccountrollups";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  ComputeEngineApi.prototype.getBillingRecordsByEnterprise = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/billingrecords/firm";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'patch', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  ComputeEngineApi.prototype.getFirstAndLastBillingRunForAccount = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/accountfirstandlastbillingrun";
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url, params)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  return ComputeEngineApi;
}(CrudMethods);

var BillingApi =
/** @class */
function () {
  function BillingApi() {
    this.advisoryDashboard = new AdvisoryApi();
    this.billingStatus = new BillingStatusApi();
    this.computeEngine = new ComputeEngineApi();
  }

  return BillingApi;
}();

var CashManagementApi =
/** @class */
function (_super) {
  __extends(CashManagementApi, _super);

  function CashManagementApi() {
    var _this = _super.call(this) || this;

    _this.base = "cashmanagement";
    return _this;
  }

  CashManagementApi.prototype.getMarketDates = function (startDate, endDate) {
    return __awaiter(this, void 0, void 0, function () {
      var url, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.base + "/marketdates/" + startDate + "/" + endDate;
            return [4
            /*yield*/
            , _super.prototype.request.call(this, 'get', url)];

          case 1:
            data = _a.sent().data;
            return [2
            /*return*/
            , data];
        }
      });
    });
  };

  return CashManagementApi;
}(Router);

export { Router, FlagsApi, ModelApi, AccountApi, AllocationApi, ReportingApi, PeopleApi, DocumentsApi, TaxHarvestingApi, ReportedModelApi, UserApi, CmsApi, SymbolApi, JobApi, RebalancerApi, BenchmarkApi, TargetWeightGroupApi, EnterprisesApi, PerformanceApi, ExclusionsApi, BillingApi, CashManagementApi };
//# sourceMappingURL=index.js.map
